import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table } from 'src/components';
import newAlert from 'src/components/newAlert';
import { onlyNumber, useQuery, replaceFloat } from 'src/core/utils/formater';
import { Modal, Input, Button } from 'antd';
import {
  columns,
  customSummary,
  MulticustomSummary,
} from './dataStructure/data';
import { start_loading, end_loading } from '../../../core/actions/loader';

const PageData = () => {
  const dispatch = useDispatch();

  const { socket, month, year } = useSelector((state) => ({
    socket: state.socket,
    month: state.data_date?.month,
    year: state.data_date?.year,
  }));
  const data_date = useSelector((state) => state.data_date);
  const [tableData, setTableData] = useState([]);
  const [summary, seTsummary] = useState({});
  const [total, seTtotal] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const query = useQuery();
  const page = query.get('page');
  const size = query.get('size');

  const showEditModal = (row) => {
    setEditRowId(row.id);
    setEditValue(row.huuli_7_1_2); // default value
    setIsModalVisible(true);
  };

  const generateTailan = () => {
    socket.on('request_out', (data) => {
      console.log('🚀 ~ socket.on ~ data:', data);
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        setTableData(data?.content?.table_data);
        seTsummary(data?.content?.sum_data);
        seTtotal(data?.content?.total);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });
    // const month = data_date?.month;
    socket.emit('request_in', {
      channel: 'hh01_view',
      content: {
        action_type: 'get_hm11_data',
        page,
        size,
        search: {},
        month,
        year,
      },
    });
    dispatch(start_loading({}));
  };

  const send_rows = () => {
    const rows = [];
    selectedRowKeys.forEach((key) => {
      const row = tableData.find((item) => item.id === key);
      if (row) {
        rows.push(row);
      }
    });
    if (selectedRowKeys.length === 0) {
      newAlert({ type: 'warning', msg: 'Сонгосон мөр байхгүй байна' });
    }

    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      if (status === 0) {
        newAlert({
          type: 'success',
          msg: content?.Message,
          functions: { Success: [generateTailan()] },
        });
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });
    // const month = data_date?.month;
    socket.emit('request_in', {
      channel: 'hh01_modify',
      content: {
        action_type: 'transfer_hm11_data',
        selected_rows: rows,
        year,
        month,
      },
    });
    dispatch(start_loading({}));
  };

  const handleSave = async () => {
    socket.on('request_out', ({ status, content }) => {
      socket.removeAllListeners('request_out');
      if (status === 0) {
        setIsModalVisible(false);
        newAlert({ type: 'success', msg: content?.Message });
        generateTailan(); // refresh table
      } else {
        newAlert({ type: 'error', msg: content?.Message });
      }
      dispatch(end_loading({}));
    });
    // 👇 send to backend here
    socket.emit('request_in', {
      channel: 'hh01_modify',
      content: {
        action_type: 'hm_11_update_huuli_7_1_2',
        id: editRowId,
        value: replaceFloat(editValue),
        year,
        month,
      },
    });
    dispatch(start_loading({}));
  };

  useEffect(() => {
    setSelectedRowKeys([]);
    if (data_date) {
      generateTailan();
    }
  }, [data_date]);

  // const title = () => <div style={{ height: '24px' }} />;
  const TableTitle = () => (
    <div style={{ marginBottom: '16px' }}>
      <Button
        disabled={selectedRowKeys.length === 0}
        className="confirm-btn ml-5"
        type="primary"
        size="small"
        onClick={() => {
          send_rows();
        }}
        style={{ marginRight: '8px' }}
      >
        ХМ11-3 шилжүүлэх
      </Button>
    </div>
  );

  return (
    <>
      <Modal
        title="Хуулийн 7.1.2 Засварлах"
        visible={isModalVisible}
        onOk={handleSave}
        onCancel={() => setIsModalVisible(false)}
        okText="Хадгалах"
        cancelText="Цуцлах"
      >
        <Input
          value={editValue}
          onChange={(e) => setEditValue(onlyNumber(e.target.value))}
          placeholder="Тоо оруулна уу"
        />
      </Modal>
      <div className="custom-hoat-table">
        <Table
          title={TableTitle}
          rowKey="id"
          total={total}
          rowSelection={
            month && String(month).split(',').length === 1
              ? {
                  selectedRowKeys,
                  onChange: (keys) => setSelectedRowKeys(keys),
                  hideSelectAll: true,
                  getCheckboxProps: (record) => ({
                    disabled: record.someCondition === false, // optional
                  }),
                }
              : null
          }
          columns={columns({
            showEditModal,
            shouldRenderEditColumn:
              month && String(month).split(',').length === 1,
          })}
          dataSource={tableData.map((row) => ({ ...row, key: row.id }))}
          scroll={{
            y: 'calc(100vh - 280px)',
          }}
          summaryList={{
            sumColumn:
              month && String(month).split(',').length === 1
                ? customSummary
                : MulticustomSummary,
            sumDataSource: summary,
          }}
        />
      </div>
    </>
  );
};

export default PageData;
